import { useCallback, useMemo } from "react";
import PublicationRecord from "../../../../models/view-models/publication-record";
import UserPublicationFavoriteRecord from "../../../../models/view-models/user-publication-favorite-record";

export interface UseFavoritePublicationsMapping {
    favoritesFromPublicationIds: (
        publicationIds: number[]
    ) => UserPublicationFavoriteRecord[];
    favoritesFromPublications: (
        publications: PublicationRecord[]
    ) => UserPublicationFavoriteRecord[];
    publications: PublicationRecord[];
}

export const useFavoritePublicationsMapping = (
    favorites: UserPublicationFavoriteRecord[]
): UseFavoritePublicationsMapping => {
    const publications = useMemo(
        () => favorites.map((upf) => upf.publication),
        [favorites]
    );

    const favoritesFromPublicationIds = useCallback(
        (publicationIds: number[]): UserPublicationFavoriteRecord[] => {
            return publicationIds
                .map((id) => favorites.find((upf) => upf.publication.id === id))
                .filter((upf) => upf != null);
        },
        [favorites]
    );

    const favoritesFromPublications = useCallback(
        (publications: PublicationRecord[]) => {
            const publicationIds = publications
                .map((p) => p.id)
                .filter((p) => p != null);

            return favoritesFromPublicationIds(publicationIds);
        },
        [favoritesFromPublicationIds]
    );

    return {
        favoritesFromPublicationIds: favoritesFromPublicationIds,
        favoritesFromPublications: favoritesFromPublications,
        publications: publications,
    };
};
